import React from "react";
import styled from "styled-components";

const StyledBurger = styled.button`
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  padding: 0;
  transition: box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
  }

  &:focus {
    outline: none;
  }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background: #0d0c1d;
    border-radius: 2px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? "translateY(7px) rotate(45deg)" : "none")};
    }
    &:nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "translateY(-7px) rotate(-45deg)" : "none")};
    }
  }
`;

const NavButton = ({ open, setOpenNav }) => {
  return (
    <StyledBurger
      open={open}
      onClick={() => setOpenNav(!open)}
      aria-label={open ? "Close menu" : "Open menu"}
      aria-expanded={open}
    >
      <span />
      <span />
      <span />
    </StyledBurger>
  );
};

export default NavButton;
